import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ls-cr-description',
  template: `
    <div>
      <p ls-heading4 class="cr-text--content">{{ title }}</p>
      <ng-content></ng-content>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CirrusDescriptionComponent {
  @Input() public title: string = null;
}
